import { render, staticRenderFns } from "./ReleChart.vue?vue&type=template&id=0fa3731f&"
import script from "./ReleChart.vue?vue&type=script&lang=js&"
export * from "./ReleChart.vue?vue&type=script&lang=js&"
import style0 from "./ReleChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports